export default __webpack_public_path__ + "static/media/3S3.ccb37c9b.svg";